import { FormikContextType } from 'formik'
import { FC } from 'react'

import { EmbroideryTypeEnum } from '../../../../../__generated__/graphql/catalog/graphql'
import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { EmbroideryService } from '../../../../../containers/EmbroideryService'
import { IconFormValues } from '../../../../../containers/EmbroideryService/types'
import { EmbroideryPlacementDetails } from '../../../../../types/graphql'
import { PlacementSelector } from '../../selectors/PlacementSelector'
import { IconPlacementWrapper } from '../../shared-form-styles'

interface Props {
  labelId: string
  iconPlacements: EmbroideryPlacementDetails[] | null
  form: Pick<
    FormikContextType<IconFormValues>,
    'values' | 'setFieldError' | 'setFieldTouched' | 'setFieldValue' | 'errors' | 'touched'
  >
  kind: EmbroideryTypeEnum
}

export const IconPlacement: FC<Props> = ({ labelId, form, iconPlacements, kind }) => {
  const { choosePlacement } = EmbroideryService.useContainer()

  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()

  if (!iconPlacements) return null

  const handleSelectIconPlacement = (iconPlacement: EmbroideryPlacementDetails) => {
    choosePlacement(kind, {
      ...iconPlacement,
      // We never want to show anything other than chest for Icon + Text Embroidery 1.5 // Kyle Corbelli 07/27/2020
      flatlayKind: 'flatlay-chest',
    })
    form.setFieldValue('iconPlacement', iconPlacement)
  }

  return (
    <IconPlacementWrapper>
      <PlacementSelector
        errorMessage={form.touched.iconPlacement ? form.errors.iconPlacement : undefined}
        label={fixtures.iconOption.iconPlacementLabel}
        labelId={labelId}
        onSelectPlacement={handleSelectIconPlacement}
        placementOptions={iconPlacements}
        selectedPlacementOption={form.values.iconPlacement}
      />
    </IconPlacementWrapper>
  )
}
